module.exports = __webpack_public_path__ + "static/media/21ECLAC31.9e852b62.jpg";